import BaseAPI from "../api";

const path: string = "tactics";

export interface createTactics {
  tacticsNo: string;
  tacticsName: string;
  tacticsDesc: string;
  tacticsStatus: string;
  idStrategy: number;
}
export interface updateTactics {
  tacticsNo: string;
  tacticsName: string;
  tacticsDesc: string;
  tacticsStatus: string;
  idStrategy: number;
}
export interface getTactics {
  page?: number;
  limit?: number;
  keyword?: string;
  idStrategy?: number;
  idFiscalYear?:number;
}

export class TacticsApi extends BaseAPI {
  public static createTactics(props: createTactics): Promise<any> {
    return this.api.post(`${path}`, props).then((res) => res);
  }
  public static getTactics(props: getTactics): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
  public static updateTactics(
    idStrategy: number,
    props: updateTactics
  ): Promise<any> {
    return this.api.patch(`${path}/${idStrategy}`, props).then((res) => res);
  }
  public static getDetail(idStrategy: number): Promise<any> {
    return this.api.get(`${path}/${idStrategy}`).then((res) => res);
  }
}
